import { SeriesDTO, IChartTooltips, numberFormatting } from "./ChartOptionsForTierParticpation";
import { wcmUrls } from "../shared/constants";
import { legendProperties, LegendProps } from "./DefaultChartOptions";

const uncappedRate = 999;
const capRateBandLabel = () => {
    return `<div class="band-text cap-rate-text">
    <b>100% growth</b> up to the cap rate.
</div>`;
}
const capRateUncappedBandLabel = () => {
    return `<div class="band-text cap-rate-text-uncapped">
    <b>Cap Rate</b> – Growth is 
    equal to any positive 
    index return.
</div>`;
}
const capRateLineLabel = `<div class="line-text cap-rate-text" aria-hidden="true"><b>Cap Rate</b> – growth capped up to this limit.</div>`;
const bufferLineLabel = '<span class="line-text">Buffer <span id="cap-rate-buffer-tooltip"></span></span>';
const ChartTooltips = [
    {
        title: 'Dual Directional Cap Rate',
        url: wcmUrls.stepRateTooltip,
        elementId: 'step-rate-tooltip',
    },
    {
        title: 'Buffer',
        url: wcmUrls.protectionTooltip,
        elementId: 'cap-rate-buffer-tooltip',
    },
    {
        title: 'Down Market',
        url: wcmUrls.downMarketTooltip,
        elementId: 'down-market-tooltip',
    },
    {
        title: 'Up Market',
        url: wcmUrls.upMarketTooltip,
        elementId: 'up-market-tooltip',
    }
];
const createTickPositions = (params: DualDirectionRateParams) => {

    const tickArray: number[] = [];
    let startTick = Math.floor(params.minDataPoint / 10) * 10;
    const endTick = (params.capRate && (params.capRate !== uncappedRate) && params.capRate > params.maxDataPoint) ? Math.ceil(params.capRate / 10) * 10 : Math.ceil(params.maxDataPoint / 10) * 10;
    
    if (startTick > params.bufferLevel) {
        startTick = params.bufferLevel
    }

    const tickIntervel = endTick > 70 || startTick < -70 ? 20 : 10;    

    for (let i = startTick - 10; i <= endTick + tickIntervel; i = i + tickIntervel) {
        tickArray.push(i);
    }

    if (params.capRate && (params.capRate !== uncappedRate) && tickArray.indexOf(params.capRate) === -1) {
        tickArray.push(params.capRate);
    }

    if (params.bufferLevel && tickArray.indexOf(params.bufferLevel) === -1) {
        tickArray.push(params.bufferLevel);
    }

    tickArray.sort(function (a, b) { return a - b });

    return tickArray;
}
const plotLinesArr = (params: DualDirectionRateParams) => {
    const lineAtZero = {
        value: 0,
        width: 3,
        color: '#999999',
        zIndex: 5
    };
    const capRateLine = {
        value: params?.capRate, // dynamic value
        width: 2,
        color: '#07639d',
        zIndex: 3,
        dashStyle: 'dash',
        label: {
            align: 'right',
            textAlign: 'left',
            x: -220,
            y: -25,
            formatter: function () {
                return capRateLineLabel;
            },
            style: {
                color: '#07639d',
                fontWeight: 'bold',
            },
            useHTML: true,
        }
    };
    const bufferLine = {
        value: params?.bufferLevel, // -5, // dynamic value
        width: 1,
        color: '#999999',
        zIndex: 3,
        label: {
            align: 'right',
            textAlign: 'left',
            x: -220,
            y: params?.bufferLevel < -5 ? -10 : -4,
            formatter: function () {
                return bufferLineLabel;
            },
            style: {
                color: '#333333',
                fontWeight: 'bold',
            },
            useHTML: true,
        }
    };
    const cappedLineArr = [lineAtZero, capRateLine, bufferLine];
    const unCappedLineArr = [lineAtZero, bufferLine];
    return (params?.capRate === uncappedRate) ? unCappedLineArr : cappedLineArr;

}
const getDownMarketLessThanEqualBufferedText = () => {
    return  'The Index Return is negative and is within or equal to the buffer, therefore the account is credited the Index Return as a positive value.';
}
const getDownMarketGreaterThanBufferText = (params: DualDirectionRateParams) => {
    return  `The Index Return is negative and exceeds the buffer, therefore the account is credited the Index Return + the Buffer (${numberFormatting(params?.strategyReturnPercentageDownMarketGreaterThanBuffer)}%.).`;
}
const getUpMarketText = (params: DualDirectionRateParams) => {
    const strategyReturnUp = params.strategyReturnPercentageUpMarket;
    const capRate = params.capRate;
    const text1 = 'The account is credited all index return up to the ' + numberFormatting(capRate) + '% cap rate.';
    const text2 = 'The account is credited the index return of ' + numberFormatting(params?.indexReturnPercentageUp) + '%.';
    if (strategyReturnUp >= capRate) {
        return text1;
    } else if (strategyReturnUp < capRate && strategyReturnUp > 0) {
        return text2;
    } else { 
        return '';
     }
}
const getCustomMarketText = (params: DualDirectionRateParams) => {
    const strategyReturnCustom = params.strategyReturnPercentageCustomMarket;
    const capRate = params.capRate;
    const text1 = 'The account is credited all index return up to the ' + numberFormatting(capRate) + '% cap rate.';
    const text2 = 'The account is credited the index return of ' + numberFormatting(params?.indexReturnPercentageCustom) + '%.';// change indexReturn as per market (up/Cusotm ?)
    if (strategyReturnCustom >= capRate) {
        return text1;
    } else if (strategyReturnCustom < capRate && strategyReturnCustom > 0) {
        return text2;
    } else if(strategyReturnCustom <= 0){
        return getDownMarketLessThanEqualBufferedText() + getDownMarketGreaterThanBufferText(params);
     } else {
        return '';
     }
}
const xAxisObj = (params: DualDirectionRateParams) => {
    return {
        categories: [
            getDownMarketLessThanEqualBufferedText(),getDownMarketGreaterThanBufferText(params),getUpMarketText(params),getCustomMarketText(params),
            ''
        ],
        labels: {
            enabled: true,
            y: 50,
            style: {
                fontSize: '14px',
                padding: '0 0 0 25px',
            },
            useHTML: true,
        },
        offset: 0,
        lineWidth: 0,
        lineColor: 'transparent',
    };
}
/* eslint-disable @typescript-eslint/no-explicit-any */
const yAxisObj = (params: DualDirectionRateParams) => {
    return {
        tickPositions: createTickPositions(params),
        labels: {
            formatter: function (): string {
                if ((params?.capRate !== uncappedRate) && (this as any).value === params?.capRate) { // dynamic values - cap Rate
                    return '<span class="label-blue label-bold y-label" aria-hidden="true">' + (this as any).value + '%</span>';
                }
                if ((this as any).value === params?.bufferLevel) { // dynamic values -buffer
                    return '<span class="label-bold y-label" aria-hidden="true">' + (this as any).value + '%</span>';
                }
                return '<span class="y-label" aria-hidden="true">' + (this as any).value + '%</span>';
            },
            useHTML: true,
            x: -10,
        },
        showLastLabel: false,
        showFirstLabel: true,
        stackLabels: {
            enabled: true,
            formatter: function (): any {
                let stackValue = '';
                
                if ((this as any).x !== 4) {
                    if ((this as any).stack) {
                       // to hide floating 0% in first column check if additional gain series is added
                       if((this as any).x === 0 && (this as any).axis.series.length === 4){
                        // if series added and still trying to plot 0 then hide it
                        if((this as any).points[2]){
                            stackValue = '<span class="dark-blue">' + numberFormatting((this as any).total) + '%</span>';
                        }
                    } else {
                        stackValue = '<span class="dark-blue">' + numberFormatting((this as any).total) + '%</span>';
                    }
                    } else {
                        stackValue = '<span class="light-blue">' + numberFormatting((this as any).total) + '%</span>';
                    }
                }

                return stackValue;
            },
            style: {
                fontSize: '15px',
                fontWeight: 'normal',
                textOutline: false
            },
            useHTML: true
        },
        title: {
            text: null
        },
        gridLineColor: 'transparent',
        plotBands: [
            {
                color: (params?.capRate === uncappedRate) ? '#FFF' : {
                    linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                    stops: [
                        [0, 'rgba(210, 229, 205, 1)'],
                        [1, 'rgba(210, 229, 205, 0.3)'],
                    ]
                },
                from: 0,
                to: (params?.capRate === uncappedRate) ? params?.maxDataPoint : params?.capRate, // dynamic value
                label: {
                    align: 'right',
                    textAlign: 'left',
                    x: -220,
                    y: params?.capRate < 5 ? 20 : 0,
                    formatter: function () {
                        return (params?.capRate === uncappedRate) ? capRateUncappedBandLabel() : capRateBandLabel();
                    },
                    style: {
                        color: '#297c00',
                    },
                    useHTML: true,
                }
            },
            {
                color: {
                    linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                    stops: [
                        [0, 'rgba(227, 228, 228, 1)'],
                        [1, 'rgba(227, 228, 228, 0.3)'],
                    ]
                },
                from: 0,
                to: params?.bufferLevel //-10
            }],
        plotLines: plotLinesArr(params),
    };
}
export class ChartOptionsForDualDirection {
    capRateParams: DualDirectionRateParams;
    chartTooltips: IChartTooltips[] | undefined;
    defs = {
        patterns: [{
            id: 'custom-pattern',
            path: {
                d: 'M 0 0 L 10 10 M 9 -1 L 11 1 M -1 9 L 1 11',
                stroke: '#FFFFFF',
                fill: '#183455',
                strokeWidth: 2
            }
        }]
    };
    chart = {
        height: 550,
        type: 'column',
        style: {
            fontFamily: 'Opensans-Regular,Arial,"Helvetica Neue",Helvetica,sans-serif',
        }
    };
    legend: LegendProps = legendProperties;
    title = {
        text: null
    };
    xAxis: object;
    yAxis: object;
    credits = {
        enabled: false
    };
    plotOptions = {
        column: {
            stacking: 'normal',
            opacity: .95
        },
        series: {
            borderRadius: 3,
            borderWidth: 0,
            dataLabels: {
                enabled: false,
            }
        }
    };
    tooltip = {
        enabled: false
    };
    series: Array<SeriesDTO>;

    
    constructor(seriesdata: Array<SeriesDTO>, capRateParams: DualDirectionRateParams, legendProps: LegendProps | null) {
        this.series = seriesdata;
        this.capRateParams = capRateParams;

        this.yAxis = yAxisObj(this.capRateParams);
        this.xAxis = xAxisObj(this.capRateParams);
        this.chartTooltips = this.capRateParams ? ChartTooltips : undefined;
        
        if (legendProps) {
            this.legend = legendProps;
        }
    }
}
export interface DualDirectionRateParams{
    capRate: number;
    indexReturnPercentageCustom: number;
    indexReturnPercentageUp: number;
    bufferLevel: number;
    minDataPoint: number;
    maxDataPoint: number;
    strategyReturnPercentageCustomMarket: number;
    strategyReturnPercentageUpMarket: number;
    strategyReturnPercentageDownMarketLessThanEqualBuffer: number;
    strategyReturnPercentageDownMarketGreaterThanBuffer: number;
}